import React from 'react'
import BrandAssetsSection from '../../sections/BrandAssetsSection'
import { BrandAssetsSliceProps } from './types'

const BrandAssetsSlice: React.FC<BrandAssetsSliceProps> = ({ slice }) => {
  const { primary, items = [] } = slice
  const { ba_title, ba_is_main_heading } = primary || {}

  return (
    <BrandAssetsSection
      heading={ba_title?.text}
      isHeadingGreen
      isMainHeading={ba_is_main_heading}
      inner="inners.primary"
      paddingTop={['24px', '', '80px']}
      paddingBottom={['80px', '', '140px']}
      headingPadding={['68px', '', '87px']}
      bgColor="#F8FAFF"
      data={items.map((item, index) => {
        const { ba_item_image, ba_item_title = '', ba_item_button_text, ba_item_button_link } = item || {}

        return {
          key: `press-kit-${index}`,
          title: ba_item_title,
          cta: {
            url: ba_item_button_link?.url,
            urlText: ba_item_button_text,
            urlIsDownload: true,
            urlIsExternal: true
          },
          image: ba_item_image
        }
      })}
    />
  )
}

export default BrandAssetsSlice
